import { Box, Tab, Tabs } from "@mui/material";
import { Category } from "../../../interfaces/Catalogue";
import styles from "./CategoryTabs.module.scss";

interface Props {
  categories: Category[];
  activeTabIndex: number;
  onTabClick: (index: number) => void;
  containerRef: React.RefObject<HTMLElement>;
}

const CategoryTabs = ({ categories, activeTabIndex, onTabClick, containerRef }: Props) => (
  <Box ref={containerRef} className={styles.tabsWrapper}>
    <Tabs
      className="tabContainer row MuiTabs-scrollableX tabContainer-menu-items"
      value={activeTabIndex}
      variant="scrollable"
      allowScrollButtonsMobile
      selectionFollowsFocus
      scrollButtons="auto"
      sx={{
        "& .MuiTabs-scrollButtons": { width: "12px" },
        "& .MuiTabs-indicator": { transition: "all 0.3s ease" },
      }}
    >
      {categories?.map((category, index) => (
        <Tab
          key={category.id || index}
          className={index === activeTabIndex ? "current-active-tab" : ""}
          value={index}
          data-tab-index={index}
          onClick={() => onTabClick(index)}
          label={category.designation.toLowerCase()}
          sx={{
            transition: "all 0.2s ease",
            minWidth: "auto",
            "&.Mui-selected": { fontWeight: 600 },
          }}
        />
      ))}
    </Tabs>
  </Box>
);

export default CategoryTabs;